import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { history } from '../../_helpers';
import { userActions } from '../../_actions';

import { GenericFooterComponent, GenericNavbarComponent } from '../../_components';

import './ResetPassword.scss';

class ResetPasswordContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: "",
      submitted: false
    }

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    if ( sessionStorage.getItem('cellit_userdata') ) return history.push('/');

    document.title = "Password Recovery - Cellit.io";
  }

  handleChange(e) {
    let val = e.target.value;
    let name = e.target.name;
  
    this.setState({[name]: val});
  }

  handleSubmit(e) {
    e.preventDefault();

    this.setState({submitted: true});

    const { email } = this.state;
    const { dispatch } = this.props;

    const obj = {
      "user": {
        "email": email
      }
    }

    if ( email ) {
      dispatch(userActions.passwordRecovery(obj));
    }
  }

  render() {
    const { email, submitted } = this.state;

    return(
      <section className="reset-password">
        <GenericNavbarComponent />

        <div className="container">
          <div className="row">
            <div className="col">
              <h1 className="title text-center">Forgot your password? <span role="img" aria-label="thinking face" aria-labelledby="thinking face">🤔</span></h1>
              <p className="subtitle text-center">Enter your e-mail address below and we'll get you back on track</p>
            </div>
          </div>

          <div className="row">
            <div className="col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 offset-3">
              <form method="POST" id="reset-password" className="form" onSubmit={this.handleSubmit}>
                <div className="content-group">
                  <div className="form-group">
                    <input
                      type="text"
                      name="email"
                      id="email"
                      className={submitted && !email ? 'form-control form-control-error' : 'form-control'}
                      autoComplete="off"
                      onChange={this.handleChange}
                      defaultValue={this.state.email}
                    />
                    <label htmlFor="email">E-mail</label>
                    {submitted && !email && <div className="input-error">Provide your email</div>}
                  </div>
                </div>

                <button type="submit" className="btn btn-blue">Submit</button>
                <Link to="/signin" className="btn btn-white-outlined">Back to Signin</Link>
              </form>
            </div>
          </div>
        </div>

        <GenericFooterComponent classes="footer footer-registering"/>
      </section>
    )
  }
}

function mapStateToProps(state) {
  const { resetting } = state.resetPasswordReducer;
  return resetting;
}

const ConnectedResetPasswordContainer = connect(mapStateToProps)(ResetPasswordContainer);
export { ConnectedResetPasswordContainer as ResetPasswordContainer }